import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';

import WinVideoMp4 from './videos/balloons/win.mp4';
import LoseVideoMp4 from './videos/balloons/lose.mp4';
import LandingVideoMp4 from './videos/balloons/landing.mp4';


import { IProps } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 23vh;
  position: relative;
  display: inline-block;
  width: 48.5vw;
  overflow: hidden;
  height: 56vh;
`;
VideoContainer.displayName = 'VideoContainer';

export const BalloonsPlugin: React.FunctionComponent<IProps> = (props) => (
  <VideoPlugin
    {...props}
    winVideo={{ mp4: WinVideoMp4 }}
    loseVideo={{ mp4: LoseVideoMp4 }}
    landingVideo={{ mp4: LandingVideoMp4 }}
    VideoWrapper={VideoContainer}
  />
);